interface GAServiceType {
    clickSendEvent: (eventName: string, message: string) => void;
}

export function trackEvent(label: string, gaService: GAServiceType, detail: string[] = []) {
    const message = detail.length ? `${label} ${detail.join(' ')}` : label;
    gaService.clickSendEvent('Click', message);
}
